import { z } from 'zod';

import { leadSchema } from './Lead';

export const leadListSchema = z.object({
  items: z.array(leadSchema),
  total: z.number(),
});

export type LeadListEntityApi = z.input<typeof leadListSchema>;

export type LeadListEntity = z.infer<typeof leadListSchema>;
